jQuery(function() {
    //get the expandable elements found on page
    var $expandables = jQuery('[data-expandable]');
    //get the nested toggle elements inside expandable elements
    var $toggles = $expandables.find('.expandable-text-container--header');

    /**
     * Toggles the expected wrapper container for data-expandable to
     * open and closed
     * @return {null} nothing to return 
     */
    var expandableClick = function() {
        /*eslint-disable-next-line no-invalid-this */
        var $this = jQuery(this);
        var $wrapper = $this.parents('[data-expandable]');
        $wrapper.addClass('closing');
        $wrapper.siblings('[data-expandable]').attr('data-expandable', "closed");
        //set small timeout to close and possible ux
        setTimeout(function() {
            $wrapper.removeClass('closing');
            $wrapper.attr('data-expandable', "open");
            $wrapper.data('expandable', "open");
        }, 100);
    }

    //assign clickable state toggle 
    $toggles.on('click', expandableClick);
});